import { default as classNames, default as cn } from "classnames";
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
import { CgArrowLeftR, CgArrowRightR } from 'react-icons/cg';
import { MdKeyboardControlKey } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from "react-router";
import { toast } from 'sonner';
import { updateBug } from '../../api/bug.service';
import { uploadVideosCard } from '../../api/cards.service';
import { fetchCreateCard, fetchEditCard, fetchUpdateCard } from '../../app/cards/cards.slice';
import { fetchDecks } from '../../app/decks/decks.slice';
import CardPreview from '../../components/CardPreview';
import Icon from '../../components/Icon';
import Loader from '../../components/Loader';
import CardInfo from './CardInfo';
import Context from './Context';
import Decks from '../Texts/Add/components/Decks';
import styles from "./NewCard.module.sass";
import Report from './Report/Report';

const NewCard = ({ isNew }) => {
    const { t } = useTranslation();
    const location = useLocation()
    const history = useHistory();

    const params = new URLSearchParams(location.search);

    const { user, cards, grammar, classification, category } = useSelector((state) => state);
    const dispatch = useDispatch();

    const [cardObject, setCardObject] = useState('')
    const { cardId } = useParams();

    const [grammarOptions, setGrammarOptions] = useState([])
    const [classificationOptions, setClassificationOptions] = useState([])

    const [cardAvailavility, setCardAvailavility] = useState(true)
    const [cardIdBlock, setCardIdBlock] = useState('')
    const [grammars, setGrammars] = useState([])
    const [classification_, setClassification] = useState([])

    const [lastUpdate, setLastUpdate] = useState(new Date())

    const [context1, setContext1] = useState('')
    const [context2, setContext2] = useState('')
    const [meaningWord, setMeaningWord] = useState('')

    const [nextCard, setNextCard] = useState('')
    const [prevCard, setPrevCard] = useState('')

    const [deckTable, setDeckTable] = useState([])

    const [updatedBy, setUpdatedBy] = useState('')

    const [newCardEdit, setNewCardEdit] = useState('')

    const [deckId, setDeckId] = useState('')
    const [notChequedContext, setNotChequedContext] = useState('')


    const [initialObject, setInitialObject] = useState('')
    const [finalObject, setFinalObject] = useState('')
    const [objectEqual, setObjectEqual] = useState(false)

    const [cardDeck, setCardDeck] = useState('')

    const [bugs, setBugs] = useState([])

    const navigation = ["Word", "Context 1", "Context 2"]

    const [activeTab, setActiveTab] = useState(navigation[0])

    const cardInfoProps = {
        cardAvailavility,
        setCardAvailavility,
        cardId: cardIdBlock,
        setCardId: setCardIdBlock,
        grammars,
        setGrammars,
        classification: classification_,
        setClassification,
        grammarOptions,
        classificationOptions
    }

    const cardContextProps = {
        context1,
        setContext1,
        context2,
        setContext2,
        meaningWord,
        navigation,
        activeTab,
        setActiveTab,
        setMeaningWord
    }

    const getDeckId = (deck) => {
        if (!deck) return null
        if (typeof deck === 'string') return deck
        return deck?._id || deck?.sourceId || null
    }

    const keyDownTextField = async (e) => {
        const target = e?.target;
        const tag = String(target?.tagName || '').toLowerCase();
        const isTypingField =
            tag === 'input' || tag === 'textarea' || tag === 'select' || target?.isContentEditable;
        if (isTypingField) return;

        var keyCode = e.keyCode;

        const isActiveTab = (element) => element === activeTab;


        if(keyCode === 37 && e?.ctrlKey === true && prevCard){ // flecha derecha
            await handleSave(true)
            window.open(`/card/edit/${prevCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
            return;
        }

        if(keyCode === 39 && e?.ctrlKey === true && nextCard){ // flecha derecha
            await handleSave(true)
            window.open(`/card/edit/${nextCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
            return;
        }

        if(keyCode === 37 && e?.metaKey === true && prevCard){ // flecha derecha
            await handleSave(true)
            window.open(`/card/edit/${prevCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
            return;
        }

        if(keyCode === 39 && e?.metaKey === true && nextCard){ // flecha derecha
            await handleSave(true)
            window.open(`/card/edit/${nextCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
            return;
        }
        

        if(keyCode === 39){ // flecha derecha
            if(navigation.findIndex(isActiveTab) !== 2){
                setActiveTab(navigation?.[navigation.findIndex(isActiveTab)+1])
            }
            return;
        }

        if(keyCode === 37){ // flecha izquierda
            if(navigation.findIndex(isActiveTab) !== 0){
                setActiveTab(navigation?.[navigation.findIndex(isActiveTab)-1])
            }
            return;
        }
    }

    useEffect(() => {
    
        window.addEventListener("keydown", keyDownTextField);
    
        return () => {
            window.removeEventListener("keydown", keyDownTextField);
        }
    }, [activeTab, nextCard, deckId, prevCard, finalObject])
    

    useEffect(async () => {
        let deckId = params.get('deckId')
        let notChequedContext = params.get('notChequedContext');
        setDeckId(deckId)
        setNotChequedContext(notChequedContext);
        if (cardId) {
            let newCardEdit_ = await dispatch(fetchEditCard({ _id: cardId, deck: deckId || '',notChequedContext:notChequedContext }));
            setNewCardEdit(newCardEdit_?.payload)
        }
    }, [cardId]);

    useEffect(() => {

        setGrammarOptions(grammar?.value?.map((c)=>{
            return{
                label: c?.title,
                value: c?._id
            }
        }))
        setClassificationOptions(classification?.value?.map((c)=>{
            return{
                label: c?.trans || c?.description,
                value: c?._id
            }
        }))
    }, [grammar, classification])


    useEffect(() => {
        dispatch(fetchDecks());
    }, [dispatch]);

    useEffect(() => {
        if(newCardEdit && !isNew){
            // const editCard = {
            //     ...newCardEdit,
            //     examples: [
            //         {
            //             ...newCardEdit?.examples?.[0],
            //             analyzed
            //         },
            //         {
            //             ...newCardEdit?.examples?.[1],
            //             analyzed
            //         }
            //     ]
            // }

            const editCard = newCardEdit



            setCardObject(editCard)
            setCardAvailavility(editCard?.active)
            setCardIdBlock(editCard?.id)
            setGrammars(editCard?.grammars?.map((c)=> {
                return{
                    label: c?.trans || c?.description,
                    value: c?._id
                }
            }))
            setClassification(editCard?.classifications?.map((c)=> {
                return{label: c?.trans, value: c?._id}
            }))
            setContext1(editCard?.examples?.[0])
            setContext2(editCard?.examples?.[1])
            setMeaningWord(editCard?.meaning)
            setLastUpdate(editCard?.lastUpdate)

            setDeckTable(editCard?.decks || [])

            setCardDeck(editCard?.cardDeck)

            setUpdatedBy(editCard?.updatedBy?.name)

            setNextCard(editCard?.cardDeck?.nextCard)
            setPrevCard(editCard?.cardDeck?.beforeCard)

            setBugs(editCard?.bugs?.filter(bug=> bug.active === true))

            let json = {
                meaning: editCard?.meaning,
                examples: [editCard?.examples?.[0], editCard?.examples?.[1]],
                _id: editCard?._id,
                grammars: editCard?.grammars?.map((c)=> c?._id),
                classifications: editCard?.classifications?.map((c)=> c?._id),
                active: editCard?.active,
                decks: editCard?.decks?.map((c)=> c?._id)
            }

            if(!editCard?.meaning?.order){
                json = {
                    ...json,
                    meaning: {
                        ...json.meaning,
                        order: 0
                    }
                }
            }
            setInitialObject(json)
        }
    }, [newCardEdit])

    useEffect(() => {
        let json = {
            meaning: meaningWord,
            examples: [context1, context2],
            grammars: grammars?.map((c)=> c?.value),
            classifications: classification_?.map((c)=> c?.value),
            active: cardAvailavility,
            decks: deckTable?.map((c)=> getDeckId(c))?.filter(Boolean)
        }


        if(!json?.meaning?.order){
            json = {
                ...json,
                meaning: {
                    ...json.meaning,
                    order: 0
                }
            }
        }

        if(newCardEdit && !isNew){ // cards.editCardValue && !isNew
            const editCard = newCardEdit // cards.editCardValue
            json._id = editCard?._id
        }


        setFinalObject(json)


        if (isEqual(json, initialObject)) {
            setObjectEqual(true)
        }else{
            setObjectEqual(false)
        }
    }, [meaningWord, context2, context1, cards, initialObject, isNew, grammars, classification_, cardAvailavility, deckTable ])
    
    const handleUploadVideo = async (obj) =>{
        if(obj?.meaning?.fileExtra){
            let body = new FormData();
            body.append('file', obj?.meaning?.fileExtra)
            body.append('card', cardId)
            body.append('order', 0)
            await uploadVideosCard(body)
        }
        if(obj?.examples?.[0]?.fileExtra){
            let body = new FormData();
            body.append('file', obj?.examples?.[0]?.fileExtra)
            body.append('card', cardId)
            body.append('order', 1)
            await uploadVideosCard(body)
        }
        if(obj?.examples?.[1]?.fileExtra){
            let body = new FormData();
            body.append('file', obj?.examples?.[1]?.fileExtra)
            body.append('card', cardId)
            body.append('order', 2)
            await uploadVideosCard(body)
        }

        return;
    }

    const handleSave = async (noPush) =>{
        if(finalObject?._id){
            let saved = await dispatch(fetchUpdateCard(finalObject))
            toast.success(t('toast.cardSaved'))
            await handleUploadVideo(finalObject)
        }else{
            let created = await dispatch(fetchCreateCard(finalObject))
            if(created?.payload?._id){
                toast.success(t('toast.cardCreated'))
                await handleUploadVideo({...finalObject, _id: created?.payload?._id})
                // history.push()
                window.open(`/card/edit/${created?.payload?._id}`, '_self')
                return;
            }
        }
        if(!noPush && !deckId) history.push('/cards')
    }

    const handleSolveReport = async (bug) =>{
        let json = {
            bugType: bug.bugType,
            lang: bug?.lang,
            _id: bug._id,
            active: false
        }
        const resp = await updateBug(json)
        if(resp?.data?.card){
            setBugs(bugs => bugs?.filter(c => c?._id !== bug?._id))
            toast.success(t('toast.markedAsSolved'))
        }else{
            toast.error(`Error (${resp?.response?.data?.message})`)
        }
    }

    return (
        <div className={styles.spacey}>
            {bugs?.map((bug, index)=>(
                <React.Fragment key={index}>
                    <Report 
                        createdBy={bug?.createdBy?.name}
                        date={bug?.lastUpdate}
                        bugType={bug?.bugType}
                        device={bug?.system}
                        reason={bug?.reason}
                        id={bug?._id}
                        handleSolve={handleSolveReport}
                        bug={bug}
                    />
                </React.Fragment>
            ))}
            <div style={{marginTop: bugs?.length > 0 ? 20 : 0, padding: '0px 40px 40px 40px'}} className={styles.row}>
                <div className={styles.col}>
                    <CardInfo {...cardInfoProps} />
                    <Context {...cardContextProps} />
                    <Decks
                        decksSelected={deckTable}
                        setDecksSelected={setDeckTable}
                        isEdit={!isNew}
                    />
                </div>
                <div className={styles.col}>
                    <div style={{ width: '100%', position: 'sticky', top: 110}}>
                        <CardPreview 
                            card={finalObject}
                            grammar={grammars?.[0]?.label}
                            classificator={classification_?.[0]?.label}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.footerBar}>
                <div className={styles.footerInner}>
                    <div className={styles.info}>
                        <Icon name="check-all" size="24" />
                        {'Last edit '}
                        <span>{dayjs(lastUpdate).format('MMM DD, YYYY - HH:mm[h]')}</span> 
                        {updatedBy &&
                            <u style={{marginLeft: 8}}>@{updatedBy}</u>
                        }
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center'}}>

                        {deckId &&
                            <small style={{ display: 'flex', marginRight: 20, alignItems: 'center', color: 'lightgray'}}>
                                <span>
                                    Use the <code>ctrl</code> + <code>arrows</code> key to switch tabs
                                </span>
                                <MdKeyboardControlKey size="20" style={{ marginLeft: 10 }} />
                                <CgArrowLeftR size="20" style={{ marginLeft: 5 }}/>
                                <CgArrowRightR size="20" style={{ marginLeft: 5 }} />
                            </small>
                        }
                        {deckId &&
                            <div style={{marginRight: 20}}>
                                <div>
                                    <small style={{color: 'gray'}}>
                                        Deck: {cardDeck?.deck?.title}
                                    </small>
                                </div>
                                <div>
                                    <small style={{color: 'gray'}}>
                                        Position {cardDeck?.actualCard} of {cardDeck?.totalCards}
                                    </small>
                                </div>
                            </div>
                        }
                        {prevCard &&
                            <button onClick={async ()=>{
                                await handleSave(true)
                                window.open(`/card/edit/${prevCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
                            }} className={cn("button-stroke-black", styles.button)}>
                                <BiLeftArrowAlt size="28" />
                            </button>
                        }
                        {nextCard &&
                            <button onClick={async ()=>{
                                await handleSave(true)
                                window.open(`/card/edit/${nextCard}?deckId=${deckId}&notChequedContext=${notChequedContext}`, '_self')
                            }} style={{marginLeft: 20}} className={cn("button-stroke-black", styles.button)}>
                                <BiRightArrowAlt size="28" />
                            </button>
                        }
                        <button disabled={objectEqual} style={{marginLeft: 20}} className={classNames("button", styles.button)} onClick={()=>handleSave(false)} >
                            {cards.isLoadingCreate ? <Loader className={styles.loader} /> : <span>Save changes</span>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewCard;
